import { Environment } from 'src/Environment';

class WebAppDynamics {
  webAppDynamicsEnabled = !Environment.current.disabledFeatures.webAppDynamics;

  _initialize() {
    window['adrum-start-time'] = new Date().getTime();
    window['adrum-config'] = {
      ...Environment.current.webAppDynamicsConfig,
    };
  }

  run() {
    if (this.webAppDynamicsEnabled) {
      const script = document.createElement('script');
      script.src = '//cdn.appdynamics.com/adrum/adrum-latest.js';
      script.id = 'appDynamics';
      document.body.appendChild(script);

      this._initialize();
    }
  }
}

export const webAppDynamicsObject = new WebAppDynamics();
